import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { euro } from "../lib/api";
import { StatusBadge } from "./StatusBadge";
import { Gauge, Fuel, Calendar } from "lucide-react";

export function VehicleCard({ v, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
    >
      <Link
        to={`/vettura/${v.id}`}
        data-testid={`vehicle-card-${v.id}`}
        className="group block bg-white rounded-3xl overflow-hidden shadow-ambient hover:shadow-floating transition-shadow duration-500"
      >
        <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
          <img
            src={v.images?.[0] || "/placeholder-car.jpg"} onError={(e) => { e.currentTarget.src = "/placeholder-car.jpg"; }}
            alt={`${v.make} ${v.model}`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          />
          <div className="absolute top-4 left-4">
            <StatusBadge status={v.status} />
          </div>
          {v.images_missing && (
            <div data-testid={`photo-updating-${v.id}`} className="absolute bottom-4 left-4 px-3 py-1.5 rounded-full bg-ink/80 text-white text-[11px] uppercase tracking-[0.15em] backdrop-blur">Foto in aggiornamento</div>
          )}
        </div>
        <div className="p-6">
          <div className="text-[11px] uppercase tracking-[0.2em] text-sand mb-1">{v.make}</div>
          <h3 className="font-serif text-2xl leading-tight text-ink">{v.model}</h3>
          <p className="text-sm text-ink-soft mt-0.5">{v.version}</p>

          <div className="flex items-center gap-4 mt-4 text-xs text-ink-soft">
            <span className="inline-flex items-center gap-1.5"><Calendar size={13} strokeWidth={1.5} />{v.year}</span>
            <span className="inline-flex items-center gap-1.5"><Gauge size={13} strokeWidth={1.5} />{Number(v.km).toLocaleString("it-IT")} km</span>
            <span className="inline-flex items-center gap-1.5"><Fuel size={13} strokeWidth={1.5} />{v.fuel}</span>
          </div>

          <div className="flex items-end justify-between mt-5 pt-5 border-t border-border">
            <div>
              <div className="font-serif text-3xl text-ink">{euro(v.price)}</div>
              {v.monthly_rate && (
                <div className="text-xs text-ink-soft mt-0.5">da {euro(v.monthly_rate)}/mese</div>
              )}
            </div>
            <span className="text-xs uppercase tracking-wider text-ink group-hover:text-sand transition-colors">Scopri →</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
